import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BookletView from './BookletView';
import ProgrammePrintExport from './ProgrammePrintExport';
import { publicProgramme, rowsOf, normProgramme, normItem } from './programmeApi';
import './programme.css';

const ProgrammeReader = () => {
  const { shareSlug } = useParams();
  const [state, setState] = useState({ loading: true });
  const [large, setLarge] = useState(false);
  const [copied, setCopied] = useState(false);
  const [showPrint, setShowPrint] = useState(false);

  useEffect(() => {
    document.body.classList.add('prog-printing');
    return () => document.body.classList.remove('prog-printing');
  }, []);

  useEffect(() => {
    let off = false;
    (async () => {
      try {
        const response = await publicProgramme(shareSlug);
        const row = response?.programme ?? response;
        if (!row?.id) { if (!off) setState({ loading: false, missing: true }); return; }
        const programme = normProgramme(row);
        const items = rowsOf(response?.items ?? row?.items).map(normItem);
        const library = rowsOf(response?.library);
        if (off) return;
        setState({ loading: false, programme, items, library });
      } catch (error) {
        if (!off) setState({ loading: false, missing: true, error: error.message });
      }
    })();
    return () => { off = true; };
  }, [shareSlug]);

  if (state.loading) return (
    <div className="min-h-screen pt-28 flex flex-col items-center justify-center gap-4">
      <div className="w-10 h-10 border-4 border-accent-gold/20 border-t-accent-gold rounded-full animate-spin" />
      <p className="text-text-muted text-sm font-bold uppercase tracking-widest">Loading programme…</p>
    </div>
  );
  const { programme } = state;
  if (state.missing) {
    return <div className="min-h-screen pt-28 text-center text-text-muted">{state.error || 'This programme is not available.'}</div>;
  }

  const showAudio = false;
  const copy = async () => {
    try { await navigator.clipboard.writeText(window.location.href); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch { /* ignore */ }
  };

  return (
    <div className="min-h-screen prog-paper bg-[#f3efe6] pt-24 pb-12 px-3">
      <div className="max-w-2xl mx-auto">
        <div className="no-print flex flex-wrap gap-2 justify-end mb-4">
          <button type="button" onClick={() => setLarge(v => !v)} className="px-3 py-2 rounded-lg border border-brand-dark bg-white text-sm font-bold">
            Large print: {large ? 'On' : 'Off'}
          </button>
          <button type="button" onClick={() => setShowPrint(true)} className="px-3 py-2 rounded-lg bg-accent-navy text-white text-sm font-bold">Print / Export</button>
          <button type="button" onClick={copy} className="px-3 py-2 rounded-lg border border-brand-dark bg-white text-sm font-bold">
            {copied ? 'Link copied' : 'Copy share link'}
          </button>
        </div>
        <BookletView programme={programme} items={state.items} library={state.library}
          large={large} showAudio={showAudio} />
      </div>
      {showPrint && (
        <ProgrammePrintExport
          programme={programme}
          items={state.items}
          library={state.library}
          showAudio={showAudio}
          onClose={() => setShowPrint(false)}
        />
      )}
    </div>
  );
};

export default ProgrammeReader;